import {ModuleSectionContainerState} from 'diy/module/sectionContainer/index';
import {ModuleSectionState} from 'diy/module/section/state';
import {ApiState} from "diy/toolbar/notificationNG/Api";
import {ModuleActionBarState} from "diy/module-action-bar/index";

export const MODULE_SECTION_STATE_KEY = "moduleSection";
export const MODULE_SECTION_CONTAINER_STATE_KEY = "moduleSectionContainer";

export interface AppState {
    moduleSection: ModuleSectionState;
    moduleSectionContainer: ModuleSectionContainerState;
    notification: ApiState;
    moduleActionBar: ModuleActionBarState;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/redux/app/state.ts
 **/